import React, { ReactNode } from "react"

import { ITEM_TYPE_LABELS, ITEM_TYPES } from "../../config/constants"
import { DetectiveCluxItem, ItemType } from "../../config/interfaces"
import { getItemsByType } from "../../helpers/game"
import Tile from "../Tile"

import "./style.scss"

interface PlateauProps {
  title: string
  background: string
  items: DetectiveCluxItem[]
  disabledTileIds: string[]
  /** Tuile dont la sélection vient d'être refusée (elle tremble) */
  shakingTileId: string | null
  /** Retour de la dernière sélection, annoncé aux lecteurs d'écran */
  feedbackMessage: string
  onSelectTile: (id: string) => void
  onShakeEnd: () => void
  /** Zone de la pioche (ou de la validation) */
  pioche: ReactNode
}

/**
 * Plateau de jeu : zones des personnages, des objets, des lieux puis de la pioche.
 * Sur grand écran, personnages et objets sont côte à côte ; sinon toutes les zones sont empilées.
 */
const Plateau = ({
  title,
  background,
  items,
  disabledTileIds,
  shakingTileId,
  feedbackMessage,
  onSelectTile,
  onShakeEnd,
  pioche,
}: PlateauProps) => {
  const renderZone = (type: ItemType) => {
    const headingId = `dc-zone-${type}`
    return (
      <section
        key={type}
        className={`dc-plateau__zone dc-plateau__zone--${type}`}
        aria-labelledby={headingId}
      >
        <h2 id={headingId} className="dc-plateau__zone-title">
          {ITEM_TYPE_LABELS[type]}
        </h2>
        <ul className="dc-plateau__tiles">
          {getItemsByType(items, type).map(item => (
            <li key={item.id}>
              <Tile
                item={item}
                isOff={disabledTileIds.includes(item.id)}
                isShaking={shakingTileId === item.id}
                onToggle={onSelectTile}
                onShakeEnd={onShakeEnd}
              />
            </li>
          ))}
        </ul>
      </section>
    )
  }

  return (
    <div
      className="dc-plateau"
      style={{ backgroundImage: `url(${background})` }}
    >
      <h1 className="dc-visually-hidden">{title}</h1>
      {ITEM_TYPES.map(renderZone)}
      <section className="dc-plateau__pioche" aria-label="Pioche d'indices">
        {pioche}
      </section>
      <p className="dc-visually-hidden" role="status">
        {feedbackMessage}
      </p>
    </div>
  )
}

export default Plateau
